import React from 'react'

/* Crypto asset logos as white glyphs on a 32x32 canvas with the brand colour as background,
   so they tile into the same square thumbnail slot other market cards use. */

const Tile = ({ bg, children, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <rect width="32" height="32" fill={bg} />
    {children}
  </svg>
)

export const BitcoinTile = props => (
  <Tile bg="#f7931a" {...props}>
    <path
      fill="#fff"
      transform="scale(0.00782)"
      d="M2947.77 1754.38c40.72-272.26-166.56-418.61-450-516.24l91.95-368.8-224.5-55.94-89.51 359.09c-59.02-14.72-119.63-28.59-179.87-42.34L2186 768.69l-224.36-55.94-92 368.68c-48.84-11.12-96.81-22.11-143.35-33.69l.26-1.16-309.59-77.31-59.72 239.78s166.56 38.18 163.05 40.53c90.91 22.69 107.35 82.87 104.62 130.57l-104.74 420.15c6.26 1.59 14.38 3.89 23.34 7.49-7.49-1.86-15.46-3.89-23.73-5.87l-146.81 588.57c-11.11 27.62-39.31 69.07-102.87 53.33 2.25 3.26-163.17-40.72-163.17-40.72l-111.46 256.98 292.15 72.83c54.35 13.63 107.61 27.89 160.06 41.3l-92.9 373.03 224.24 55.94 92-369.07c61.26 16.63 120.71 31.97 178.91 46.43l-91.69 367.33 224.51 55.94 92.89-372.33c382.82 72.45 670.67 43.24 791.83-303.02 97.63-278.78-4.86-439.58-206.26-544.44 146.69-33.83 257.18-130.31 286.64-329.61l-.07-.05zm-512.93 719.26c-69.38 278.78-538.76 128.08-690.94 90.29l123.28-494.2c152.17 37.99 640.17 113.17 567.67 403.91zm69.43-723.3c-63.29 253.58-453.96 124.75-580.69 93.16l111.77-448.21c126.73 31.59 534.85 90.55 468.94 355.05h-.02z"
    />
  </Tile>
)

export const EthereumTile = props => (
  <Tile bg="#627eea" {...props}>
    <g fill="#fff" transform="scale(1.6)">
      <path d="M10.311 2.5v5.544l4.686 2.094z" fillOpacity=".602" />
      <path d="M10.311 2.5l-4.686 7.637 4.686-2.093z" />
      <path d="M10.311 13.73v3.767L15 11.01z" fillOpacity=".602" />
      <path d="M10.311 17.497v-3.768L5.625 11.01z" />
      <path d="M10.311 12.858l4.686-2.72-4.686-2.093z" fillOpacity=".2" />
      <path d="M5.625 10.137l4.686 2.721V8.045z" fillOpacity=".602" />
    </g>
  </Tile>
)

export const SolanaTile = props => (
  <Tile bg="#000" {...props}>
    <defs>
      <linearGradient
        id="sol-tile-gradient"
        x1="463"
        y1="205.16"
        x2="182.39"
        y2="742.62"
        gradientTransform="translate(0 -198)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#00ffa3" />
        <stop offset="1" stopColor="#dc1fff" />
      </linearGradient>
    </defs>
    <g transform="translate(7 9) scale(0.0355)" fill="url(#sol-tile-gradient)">
      <path
        d="M84.53,358.89A16.63,16.63,0,0,1,96.28,354H501.73a8.3,8.3,0,0,1,5.87,14.18l-80.09,80.09a16.61,16.61,0,0,1-11.75,4.86H10.31A8.31,8.31,0,0,1,4.43,439Z"
        transform="translate(-1.98 -55)"
      />
      <path
        d="M84.53,59.85A17.08,17.08,0,0,1,96.28,55H501.73a8.3,8.3,0,0,1,5.87,14.18l-80.09,80.09a16.61,16.61,0,0,1-11.75,4.86H10.31A8.31,8.31,0,0,1,4.43,140Z"
        transform="translate(-1.98 -55)"
      />
      <path
        d="M427.51,208.42a16.61,16.61,0,0,0-11.75-4.86H10.31a8.31,8.31,0,0,0-5.88,14.18l80.1,80.09a16.6,16.6,0,0,0,11.75,4.86H501.73a8.3,8.3,0,0,0,5.87-14.18Z"
        transform="translate(-1.98 -55)"
      />
    </g>
  </Tile>
)

export const BnbTile = props => (
  <Tile bg="#f3ba2f" {...props}>
    <g fill="#fff" transform="scale(1.6)">
      <path d="M10 6.575L7.572 9.002 6.16 7.59 10 3.75l3.841 3.841-1.412 1.413z" />
      <path d="M5.162 8.588L3.75 10l1.412 1.412L6.575 10z" />
      <path d="M10 13.425l-2.428-2.428-1.414 1.411.002.002L10 16.25l3.841-3.842-1.412-1.412z" />
      <path d="M14.838 8.588L13.425 10l1.412 1.412L16.25 10z" />
      <path d="M11.434 10h-.002L10 8.566 8.94 9.625l-.121.122-.25.251-.003.002.002.002L10 11.434 11.434 10z" />
    </g>
  </Tile>
)

export const XrpTile = props => (
  <Tile bg="#23292f" {...props}>
    <path
      fill="#fff"
      transform="translate(6.5 8) scale(0.037)"
      d="M437 0h74L358 151.7c-55.3 54.7-145 54.7-200.3 0L4.4 0h74.1l116 114.8c35 34.5 91.5 34.5 126.5 0L437 0zM73.6 424H0l154-152.5c55.3-54.7 145-54.7 200.3 0L508.4 424h-74.1L318 309.2c-35-34.5-91.5-34.5-126.5 0L73.6 424z"
    />
  </Tile>
)

const ring = (count, radius, r, offsetDeg) =>
  Array.from({ length: count }, (_, i) => {
    const angle = ((offsetDeg + (360 / count) * i) * Math.PI) / 180
    return <circle key={`${radius}-${i}`} cx={16 + radius * Math.cos(angle)} cy={16 + radius * Math.sin(angle)} r={r} />
  })

export const CardanoTile = props => (
  <Tile bg="#0033ad" {...props}>
    <g fill="#fff">
      <circle cx="16" cy="16" r="2.1" />
      {ring(6, 5.2, 1.05, 30)}
      {ring(6, 9.2, 1.35, 0)}
      {ring(6, 11.6, 0.6, 30)}
    </g>
  </Tile>
)

export const DogecoinTile = props => (
  <Tile bg="#c2a633" {...props}>
    <g transform="scale(0.016)">
      <path
        fill="#fff"
        d="M1039.29 1540.1H677.14v-481.46H549.48V940.7h127.65V459.21h310.82c73.53 0 560.56-15.27 560.56 549.48 0 574.09-509.21 531.41-509.21 531.41z"
      />
      <path
        fill="#c2a633"
        d="M1024 659H881.12v281.69h224.79v117.94H881.12v281.67H1031c38.51 0 316.16 4.35 315.73-327.72S1077.44 659 1024 659z"
      />
    </g>
  </Tile>
)
